import { PacmanLoader } from 'react-spinners'

const PageLoadingIndicator = () => <PacmanLoader color="silver" />

export default PageLoadingIndicator
